/* eslint-disable no-nested-ternary */
import React, {memo} from 'react';

// material-ui
import {Box, Grid, Typography} from '@mui/material';
import {useTheme} from '@mui/styles';

import {useDispatch, useSelector} from 'react-redux';
import {getCustomers, selectCustomerById} from 'store/customers/customersSlice';
import {RootState} from 'store';

// project imports
import config from 'config';
import SubCard from 'ui-component/cards/SubCard';
import Logo from 'ui-component/Logo';
import MyChip from 'ui-component/extended/Chip';

import {IconCurrencyShekel} from '@tabler/icons';

// Locale
import {format} from 'date-fns';
import {enUS, he} from 'date-fns/locale';
import {FormattedMessage} from 'react-intl';

// types
import DocumentHeaderPreview from '../document_header_preview/DocumentHeaderPreview';
import {roundDecimals} from '../../../../../fromKotlin/nkutils';
import DocumentClientDetails from '../document_header_preview/DocumentClientDetails';
import {ExtendedDocument} from '../../../../../types/DocumentsTypes/Document';
import PreviewDocumentComments from '../PreviewComments';


const DebtPreview = ({ ...document }: ExtendedDocument) => {
    const theme = useTheme();
    const dispatch = useDispatch();

    // TODO: Change to single customer fetching
    const customer = useSelector((state: RootState) => selectCustomerById(state, document.entId));
    React.useEffect(() => {
        if (!customer) dispatch(getCustomers());
    }, [ dispatch]);
    if (!customer) return <Box />;
    const address = customer.street && customer.streetNumber ? `${customer.street}, ${customer.streetNumber}` : customer.street;
    return (
        <SubCard
            darkTitle
            title={
                <Typography fontWeight='bold'>
                    חוב קודם
                </Typography>
            }
            secondary={<Logo width={50} />}
        >
            <Grid container spacing={2}>
                <DocumentHeaderPreview />
                <Grid item xs={12}>
                    <Grid container>
                        <DocumentClientDetails address={address} name={customer.name}
                                               businessName={customer.businessName} businessId={customer.businessId}
                                               phone={customer.phone} email={customer.email} id={customer.id} external_id={customer.externalId}/>
                        <Grid item sm={6}>
                            <Grid container>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    פרטי חוב
                                </Typography>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant='body2'>
                                                <FormattedMessage id='Date' />:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography variant='body2'>
                                                {format(document.date, 'PPP', {
                                                    locale: config.i18n === 'he' ? he : enUS
                                                })}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2'>
                                                תאריך הנפקה:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography variant='body2'>
                                                {format(document.issueDate, 'PPPPp', {
                                                    locale: config.i18n === 'he' ? he : enUS
                                                })}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2'>
                                                <FormattedMessage id='Status' />:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <MyChip
                                                label={<FormattedMessage id={document.status} />}
                                                variant='outlined'
                                                size='small'
                                                chipcolor={
                                                    document.status === 'pending_approval'
                                                        ? 'warning'
                                                        : document.status === 'approved'
                                                            ? 'success'
                                                            : document.status === 'open'
                                                                ? 'error'
                                                                : ''
                                                }
                                            />
                                        </Grid>
                                        <>
                                            <Grid item xs={4}>
                                                <Typography variant='body2'>
                                                    סוכן:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Typography variant='body2'>
                                                    {document.agent}
                                                </Typography>
                                            </Grid>
                                        </>
                                        {document.orderId  ?   <>
                                            <Grid item xs={4}>
                                                <Typography variant='body2'>
                                                    הזמנה:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Typography variant='body2'>
                                                    {document.orderId}
                                                </Typography>
                                            </Grid>
                                        </> : undefined}

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid item xs={4}>
                        <Typography variant='body2'>
                            הערות:
                        </Typography>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography variant='body2'>
                            {document.comment}
                        </Typography>
                    </Grid>

                </Grid>
                <Grid item xs={12}>
                    <SubCard
                        sx={{
                            bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
                        }}
                    >
                        <Grid container rowSpacing={0}>
                            <Grid item xs={4}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    חובה
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    זכות
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    סהכ
                                </Typography>
                            </Grid>

                            <Grid item style={{direction:'ltr',textAlign:'right'}} xs={4}>
                                <IconCurrencyShekel size={10} color='black' />
                                {roundDecimals(document.nkObject.positive,3)}

                            </Grid>
                            <Grid item style={{direction:'ltr',textAlign:'right'}} xs={4}>
                                <IconCurrencyShekel size={10} color='black' />
                                {roundDecimals(document.nkObject.negative,3)}

                            </Grid>
                            <Grid item style={{direction:'ltr',textAlign:'right'}} xs={4}>
                                <IconCurrencyShekel size={10} color='black' />
                                {roundDecimals(document.mainValue,3)}

                            </Grid>
                        </Grid>
                    </SubCard>
                </Grid>
            </Grid>
        </SubCard>
    );
};

export default memo(DebtPreview);
